module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toc"
  }, [_c('div', {
    staticClass: "toc-headline"
  }, [_vm._v("\n    " + _vm._s(_vm.data.headline) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "toc-indexes"
  }, _vm._l((_vm.data.index), function(indexName, index) {
    return _c('toc-index', {
      key: indexName,
      attrs: {
        "text": indexName,
        "numbered": _vm.data.numbered,
        "index": index
      },
      nativeOn: {
        "click": function($event) {
          _vm.changeSubSection(index)
        }
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029b8bd8","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/combinedBlocks/Toc.vue
// module id = 509
// module chunks = 0